import { render, staticRenderFns } from "./Time_management_todolist.vue?vue&type=template&id=1c929e5b"
import script from "./Time_management_todolist.vue?vue&type=script&lang=js"
export * from "./Time_management_todolist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports